<script setup>
import { defineProps, defineEmits } from "vue";

const emit = defineEmits(["close"]);

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  customClass: {
    type: String,
    default: "z-10",
  },
  customContentClass: {
    type: String,
    default: "p-8",
  },
  scrollable: {
    type: Boolean,
    default: false,
  },
  headerColorClass: {
    type: String,
    default: "bg-teal-accent",
  },
  fullScreen: {
    type: Boolean,
    default: false,
  },
  showCloseButton: {
    type: Boolean,
    default: true,
  },
});
</script>
<template>
  <div v-if="props.open" :class="customClass">
    <div
      class="fixed inset-0 hidden bg-university-primary opacity-50 sm:block z-10"
    ></div>
    <div
      class="fixed inset-0 overflow-y-auto bg-gray-75 sm:bg-transparent"
      :class="customClass"
    >
      <div
        class="flex items-center justify-center min-h-screen"
        :class="{ 'sm:p-5': fullScreen }"
      >
        <!-- Box Wrapper -->
        <div
          class="w-full"
          :class="
            fullScreen
              ? 'bg-white min-h-screen'
              : 'bg-gray-75 fixed top-0 md:top-auto md:w-[800px]'
          "
        >
          <!-- HeaderPopup Wrapper -->
          <div
            data-testid="popup-header"
            class="p-4 flex space-x-2 justify-between items-center"
            :class="props.headerColorClass"
          >
            <h3 class="uppercase font-semibold text-black">
              <slot name="title"></slot>
            </h3>
            <a class="cursor-pointer" @click="emit('close', false)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </a>
          </div>

          <!-- Popup content -->
          <div class="text-center" :class="props.customContentClass">
            <div :class="[scrollable ? 'overflow-y-auto' : '']">
              <slot name="content"></slot>
            </div>
            <!-- <p class="text-teal-950 opacity-60">{{ content }}</p> -->
            <!-- Buttons Group -->

            <div v-if="props.showCloseButton" class="mt-6">
              <button
                :class="`border-2 ${secondaryColorClassOutlined} font-bold py-2 px-4 uppercase`"
                @click="emit('close', false)"
              >
                Close
              </button>
            </div>
          </div>
          <!--FIM Popup content -->
        </div>
      </div>
    </div>
  </div>
</template>
